(() => {
  const selector="[data-veyrissa-component=\"collection-product-grid\"] .product-card--has-secondary";

  function sync(card){
    const media=card.querySelector('.product-card__media');
    if(!media)return;
    const index=media.clientWidth>0 && media.scrollLeft > media.clientWidth*0.45 ? 1 : 0;
    card.dataset.veyrissaVisibleMedia=index===1?'02':'01';
    const dots=card.querySelectorAll('.product-card__media-dot');
    if(dots.length>=2){
      dots[0].style.setProperty('background',index===0?'#111':'rgba(17,17,17,.26)','important');
      dots[1].style.setProperty('background',index===1?'#111':'rgba(17,17,17,.26)','important');
    }
  }

  function bind(card){
    if(card.dataset.veyrissaNativeSwipeBound==='1')return;
    const media=card.querySelector('.product-card__media');
    if(!media)return;
    card.dataset.veyrissaNativeSwipeBound='1';

    let startX=0,startY=0,moved=false,down=false,raf=0;

    const onStart=(x,y)=>{
      startX=x;startY=y;moved=false;down=true;
    };
    const onMove=(x,y)=>{
      if(!down)return;
      if(Math.abs(x-startX)>8 && Math.abs(x-startX)>Math.abs(y-startY)) moved=true;
    };
    const onEnd=()=>{
      down=false;
      window.setTimeout(()=>{moved=false;},180);
      sync(card);
    };

    media.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse' && e.button!==0)return;
      onStart(e.clientX,e.clientY);
      try{media.setPointerCapture(e.pointerId);}catch(_){}
    },{passive:true});
    media.addEventListener('pointermove',e=>onMove(e.clientX,e.clientY),{passive:true});
    media.addEventListener('pointerup',onEnd,{passive:true});
    media.addEventListener('pointercancel',onEnd,{passive:true});

    media.addEventListener('touchstart',e=>{
      if(e.touches&&e.touches.length===1)onStart(e.touches[0].clientX,e.touches[0].clientY);
    },{passive:true});
    media.addEventListener('touchmove',e=>{
      if(e.touches&&e.touches.length===1)onMove(e.touches[0].clientX,e.touches[0].clientY);
    },{passive:true});
    media.addEventListener('touchend',onEnd,{passive:true});

    media.addEventListener('scroll',()=>{
      if(raf)return;
      raf=requestAnimationFrame(()=>{raf=0;sync(card);});
    },{passive:true});

    media.addEventListener('click',e=>{
      if(!moved)return;
      e.preventDefault();
      e.stopPropagation();
    },true);

    requestAnimationFrame(()=>{
      media.scrollLeft=0;
      sync(card);
    });
  }

  function run(root=document){
    if(!root||!root.querySelectorAll)return;
    root.querySelectorAll(selector).forEach(bind);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>run(document),{once:true});
  }else{
    run(document);
  }

  document.addEventListener('shopify:section:load',e=>run(e.target||document));
  window.addEventListener('pageshow',()=>run(document));
})();